/**
 * components/Bar/ProgressBar
 * The 6px bar on the custodian's purpose card — how much of a purpose wallet is
 * left. A single fill over the standard track; the stacked variant is a
 * different component because a one-segment stack would need a fake segment.
 */
import { StyleSheet, View } from 'react-native';
import { neutral } from '../../theme/colors';
import { radii } from '../../theme/radii';

export interface ProgressBarProps {
  /** 0–1. Values outside are clamped rather than overflowing the track. */
  ratio: number;
  height?: number;
  color?: string;
}

export function ProgressBar({ ratio, height = 6, color = neutral.ink }: ProgressBarProps) {
  const percent = Math.max(0, Math.min(1, Number.isFinite(ratio) ? ratio : 0)) * 100;
  return (
    <View style={[styles.track, { height }]}>
      <View style={[styles.fill, { width: `${percent}%`, backgroundColor: color }]} />
    </View>
  );
}

const styles = StyleSheet.create({
  track: {
    width: '100%',
    borderRadius: radii.pill,
    backgroundColor: neutral.ruleLight,
    overflow: 'hidden',
  },
  fill: { height: '100%' },
});

export default ProgressBar;
